import React, { useMemo, useState } from "react";

/**
 * İşletme (organization_category) çoklu seçim + listede arama
 * @param {{ id: number, name: string }[]} options
 * @param {number[]} value
 * @param {(ids: number[]) => void} onChange
 */
export default function OrgCategoryMultiSelect({ options, value, onChange, disabled, label }) {
  const [q, setQ] = useState("");
  const selectedSet = useMemo(() => new Set((value || []).map((x) => Number(x)).filter(Boolean)), [value]);

  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    const list = Array.isArray(options) ? options : [];
    if (!t) return list;
    return list.filter(
      (o) =>
        String(o.name || "")
          .toLowerCase()
          .includes(t) || String(o.id || "").includes(t)
    );
  }, [options, q]);

  const toggle = (id) => {
    const n = Number(id);
    if (!n) return;
    const next = new Set(selectedSet);
    if (next.has(n)) next.delete(n);
    else next.add(n);
    onChange(Array.from(next).sort((a, b) => a - b));
  };

  return (
    <div className="col-12">
      {label != null && <label className="form-label">{label}</label>}
      <input
        type="search"
        className="form-control mb-2"
        placeholder="Kategori ara (ad veya ID)…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        disabled={disabled}
        autoComplete="off"
      />
      <div className="border rounded p-2 bg-light" style={{ maxHeight: 240, overflowY: "auto" }}>
        {filtered.length === 0 && <span className="text-muted small">Sonuç yok</span>}
        {filtered.map((o) => (
          <div key={o.id} className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id={`orgcat-${o.id}`}
              checked={selectedSet.has(Number(o.id))}
              onChange={() => toggle(o.id)}
              disabled={disabled}
            />
            <label className="form-check-label" htmlFor={`orgcat-${o.id}`}>
              {o.name} <span className="text-muted small">({o.id})</span>
            </label>
          </div>
        ))}
      </div>
      {value?.length > 0 && <div className="small text-secondary mt-1">Seçili ID: {value.join(", ")}</div>}
    </div>
  );
}
